import React from 'react';

function Row(props) {
    return (
        <div className="row-items">
            {props.children}
        </div>
    );
}

export default Row;